import types from '../mutation-types';
import MessageAPI from '../../api/inbox/message';

export const state = {
  selectedMessageIds: [],
  isSelectionMode: false,
  uiFlags: {
    isForwarding: false,
  },
};

export const getters = {
  getSelectedMessageIds: _state => _state.selectedMessageIds,
  isSelectionMode: _state => _state.isSelectionMode,
  selectedMessageCount: _state => _state.selectedMessageIds.length,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  toggleSelectionMode({ commit }, enabled) {
    commit(types.SET_MESSAGE_SELECTION_MODE, enabled);
    if (!enabled) {
      commit(types.CLEAR_SELECTED_MESSAGES);
    }
  },

  toggleMessageSelection({ commit, state: _state }, messageId) {
    if (_state.selectedMessageIds.includes(messageId)) {
      commit(types.REMOVE_SELECTED_MESSAGE, messageId);
    } else {
      commit(types.ADD_SELECTED_MESSAGE, messageId);
    }
  },

  selectMessage({ commit, state: _state }, messageId) {
    if (!_state.selectedMessageIds.includes(messageId)) {
      commit(types.ADD_SELECTED_MESSAGE, messageId);
    }
  },

  deselectMessage({ commit }, messageId) {
    commit(types.REMOVE_SELECTED_MESSAGE, messageId);
  },

  selectAllMessages({ commit }, messageIds) {
    commit(types.SET_SELECTED_MESSAGES, messageIds);
  },

  clearSelectedMessages({ commit }) {
    commit(types.CLEAR_SELECTED_MESSAGES);
  },

  async forwardMessages(
    { commit, state: _state, rootGetters },
    conversationIds
  ) {
    commit(types.SET_MESSAGE_FORWARD_UI_FLAG, { isForwarding: true });

    try {
      const accountId = rootGetters.getCurrentAccountId;
      const response = await MessageAPI.forward(
        accountId,
        _state.selectedMessageIds,
        conversationIds
      );

      commit(types.SET_MESSAGE_SELECTION_MODE, false);
      commit(types.CLEAR_SELECTED_MESSAGES);

      return response.data;
    } finally {
      commit(types.SET_MESSAGE_FORWARD_UI_FLAG, { isForwarding: false });
    }
  },

  exitSelectionMode({ commit }) {
    commit(types.SET_MESSAGE_SELECTION_MODE, false);
    commit(types.CLEAR_SELECTED_MESSAGES);
  },
};

export const mutations = {
  [types.SET_MESSAGE_SELECTION_MODE](_state, enabled) {
    _state.isSelectionMode = enabled;
  },

  [types.ADD_SELECTED_MESSAGE](_state, messageId) {
    if (!_state.selectedMessageIds.includes(messageId)) {
      _state.selectedMessageIds.push(messageId);
    }
  },

  [types.REMOVE_SELECTED_MESSAGE](_state, messageId) {
    _state.selectedMessageIds = _state.selectedMessageIds.filter(
      id => id !== messageId
    );
  },

  [types.SET_SELECTED_MESSAGES](_state, messageIds) {
    _state.selectedMessageIds = [...messageIds];
  },

  [types.CLEAR_SELECTED_MESSAGES](_state) {
    _state.selectedMessageIds = [];
  },

  [types.SET_MESSAGE_FORWARD_UI_FLAG](_state, flags) {
    _state.uiFlags = { ..._state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
